export default [
	{
		modulo: 19,
		privilegio: 216,
		routerName: 'ticket',
		routerPath: '/ticket',
		componentName: 'Ticket',
		componentPath: 'modules/layout/suporte/ticket/main'
	},
	{
		modulo: 19,
		privilegio: 219,
		routerName: 'suporte-termo-de-uso',
		routerPath: '/suporte-termo-de-uso',
		componentName: 'SuporteTermoDeUso',
		componentPath: 'modules/layout/suporte/termo-de-uso/main'
	},
	{
		modulo: 19,
		privilegio: 219,
		routerName: 'suporte-exportar-dados',
		routerPath: '/suporte-exportar-dados',
		componentName: 'SuporteExportarDados',
		componentPath: 'modules/layout/suporte/exportar-dados/main'
	},
]
